export default __webpack_public_path__ + "static/media/menu-pipeline.8c84cfb8.svg";